import api from 'helpers/api';
import { toast } from 'sonner';
import authHeader from 'helpers/auth-headers';

class UserService {
  setCurrentUser(user) {
    localStorage.setItem('user', JSON.stringify(user));
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem('user'));
  }

  getCurrentUserId() {
    const user = this.getCurrentUser();
    return user ? user.id : null;
  }

  updateLocalBalance(balance) {
    let storedUser = JSON.parse(localStorage.getItem('user'));
    if (storedUser) {
      storedUser.balance = balance;
      localStorage.setItem('user', JSON.stringify(storedUser));
    }
  }

  async getUserOrders(user_id) {
    try {
      const response = await api.get(`/api/v2/users/${user_id}/orders`, { headers: authHeader() });
      return response.data;
    } catch (error) {
      toast.error('Something went wrong', { description: 'Error getting user orders' });
      return [];
    }
  }
}

export default new UserService();
